<template>
    <div class="countdownWrapper">
        <div class="countdown">

            <div class="block">
                <p class="digit">{{ seconds | two_digits }}</p>
                <p class="text">{{$t('seconds')}}</p>
            </div>
            <div class="block">
                <p class="digit">{{ minutes | two_digits }}</p>
                <p class="text">{{$t('minutes')}}</p>
            </div>
            <div class="block">
                <p class="digit">{{ hours | two_digits }}</p>
                <p class="text">{{$t('hours')}}</p>
            </div>
            <div class="block">
                <p class="digit">{{ days | two_digits }}</p>
                <p class="text">{{$t('days')}}</p>
            </div>
        </div>
        <div style="color:#16233A; font-size: 17px;">{{ $t('timerTill') }}</div>
    </div>
</template>

<script>

    export default {
        name: "CountDownTimer",
        mounted() {
            window.setInterval(() => {
                this.now = Math.trunc((new Date()).getTime() / 1000);
            },1000);
        },
        props: {
            date: {
                type: Number
            }
        },
        data() {
            return {
                now: Math.trunc((new Date()).getTime() / 1000)
            }
        },
        computed: {
            dateInMilliseconds() {
                return Math.trunc(this.date * 1000)
            },
            seconds() {
                return (this.dateInMilliseconds - this.now) % 60;
            },
            minutes() {
                return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
            },
            hours() {
                return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
            },
            days() {
                return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
            }
        },
        filters:{
            two_digits: value => {
                if (value < 0) {
                    return '00';
                }
                if (value.toString().length <= 1) {
                    return `0${value}`;
                }
                return value;
            }
        }
    }
</script>

<style scoped>

    .countdown {
        display: flex;
        justify-content: center;
    }

    .block {
        display: flex;
        flex-direction: column;
        margin: 5px 5px 0px;
    }

    .text {
        color: #16233A;
        font-size: 10px;
        font-weight: bold;
        text-align: center;
    }

    .digit {
        color: #cccfd0;
        font-size: 20px;
        font-weight: bold;
        margin: auto;
        text-align: center;
    }

    .countdownWrapper{
        background-color: #fcfcfc;
    }

</style>
